import { Box } from '@mui/material'
import { colors } from '@theme/variables'

import { CustomTooltip } from './CustomTooltip'

export const InfoIcon = ({ title }: { title: string }) => {
  return (
    <CustomTooltip title={title} placement="top">
      <Box
        width="18px"
        height="18px"
        borderRadius="50%"
        bgcolor="#797979"
        color={colors.white}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        i
      </Box>
    </CustomTooltip>
  )
}
